import request from './_config'

const path = `campaigns`

export function getCampaigns(tiktokAccountId, params = null) {
    return request({
        url: `${path}/${tiktokAccountId}`,
        method: 'get',
        params
    })
}

export function updateCampaignStatus(tiktokAccountId, data) {
    return request({
        url: `${path}/status/${tiktokAccountId}`,
        method: 'post',
        data: {
            advertiser_id: data.advertiser_id,
            campaign_ids: data.campaign_ids,
            belong_to_atosa: data.belong_to_atosa,
            operation_status: data.operation_status
        }
    })
}

export function updateCampaign(tiktokAccountId, data) {
    return request({
        url: `${path}/${tiktokAccountId}`,
        method: 'put',
        data: {
            ...data,
            advertiser_id: data.advertiser_id,
            campaign_id: data.campaign_id
        }
    })
}

export function createCampaign(tiktokAccountId, data) {
    return request({
        url: `${path}/${tiktokAccountId}`,
        method: 'post',
        data: {
            operation_status: 'ENABLE',
            belong_to_atosa: data.belong_to_atosa,
            advertiser_id: data.advertiser_id,
            campaign_name: data.campaign_name,
            objective_type: data.objective_type,
            budget_mode: data.budget_mode,
            budget: data.budget,
            campaign_type: data.campaign_type,
            app_promotion_type: data.app_promotion_type,
            special_industries: data.special_industries,
            rf_campaign_type: data.rf_campaign_type
        }
    })
}
